export default __webpack_public_path__ + "static/media/scrapeing-recipe.3b618f6e.svg";